import React, { useState, useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import { FaPlus, FaTrash } from "react-icons/fa";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getAllPointOfSales,
  getProducts,
  createTransfer,
  getPublicProducts,
} from "UpdatedFeatures/api";
import { toast } from "react-toastify";
import { Puff } from "react-loader-spinner";
import { Autocomplete, TextField } from "@mui/material";

const AddTransferModal = ({ open, setOpen }) => {
  const queryClient = useQueryClient();
  const [senderPosId, setSenderPosId] = useState("");
  console.log(senderPosId);
  const [receivers, setReceivers] = useState([
    { receiver_pos_id: "", products: [{ product_id: "", quantity: 1 }] },
  ]);
  const [searchTerm, setSearchTerm] = useState("");
  const [availableQuantities, setAvailableQuantities] = useState({});

  // Fetch all point of sales
  const { data: posData, isLoading: posLoading } = useQuery({
    queryKey: ["pointOfSales"],
    queryFn: () => getAllPointOfSales(),
    enabled: open,
  });

  // Fetch products
  // const { data: productsData, isLoading: productsLoading } = useQuery({
  //   queryKey: ["products", searchTerm],
  //   queryFn: () =>
  //     getProducts(searchTerm, null, "", "", "", null, "", "", [], true),
  // });
  const { data: PublicProducts, isLoading: productsLoading } = useQuery({
    queryKey: ["products", searchTerm],
    queryFn: () => getPublicProducts(searchTerm, null, "", "", "", null, "", "", [], false, true),

  });
  console.log(PublicProducts);
  // Create transfer mutation
  const transferMutation = useMutation({
    mutationFn: createTransfer,
    onSuccess: () => {
      toast.success("Transfert créé avec succès");
      queryClient.invalidateQueries(["transfers"]);
      setOpen(false);
      resetForm();
    },
    onError: (error) => {
      // toast.error(`Erreur lors de la création du transfert: ${error.message}`);
      toast.error(
        `Erreur lors de la création du transfert: La quantité Demandéé du Point de vente d'origine n'est pas disponible.`
      );
    },
  });

  const resetForm = () => {
    setSenderPosId("");
    setReceivers([
      { receiver_pos_id: "", products: [{ product_id: "", quantity: 1 }] },
    ]);
  };

  // Add a new receiver POS
  const addReceiver = () => {
    setReceivers([
      ...receivers,
      { receiver_pos_id: "", products: [{ product_id: "", quantity: 1 }] },
    ]);
  };

  // Remove a receiver POS
  const removeReceiver = (index) => {
    const newReceivers = [...receivers];
    newReceivers.splice(index, 1);
    setReceivers(newReceivers);
  };

  // Add a product to a receiver
  const addProduct = (receiverIndex) => {
    const newReceivers = [...receivers];
    newReceivers[receiverIndex].products.push({ product_id: "", quantity: 1 });
    setReceivers(newReceivers);
  };

  // Remove a product from a receiver
  const removeProduct = (receiverIndex, productIndex) => {
    const newReceivers = [...receivers];
    newReceivers[receiverIndex].products.splice(productIndex, 1);
    setReceivers(newReceivers);
  };

  // Update receiver POS ID
  const updateReceiverPosId = (index, value) => {
    const newReceivers = [...receivers];
    newReceivers[index].receiver_pos_id = value;
    setReceivers(newReceivers);
  };

  // Update product details
  const updateProduct = (receiverIndex, productIndex, field, value) => {
    const newReceivers = [...receivers];
    newReceivers[receiverIndex].products[productIndex][field] =
      field === "quantity" ? parseInt(value) : value;
    setReceivers(newReceivers);
  };

  // Modify useEffect to properly handle multiple products per receiver
  useEffect(() => {
    if (senderPosId) {
      // Update quantities for all selected products when sender POS changes
      receivers.forEach((receiver, receiverIndex) => {
        receiver.products.forEach((product, productIndex) => {
          if (product.product_id) {
            updateAvailableQuantity(
              receiverIndex,
              productIndex,
              product.product_id
            );
          }
        });
      });
    } else {
      // Reset all quantities if sender POS is cleared
      setAvailableQuantities({});
    }
  }, [senderPosId, PublicProducts]);

  // Update the function to use a composite key
  const updateAvailableQuantity = (receiverIndex, productIndex, productId) => {
    const quantityKey = `${receiverIndex}-${productIndex}`;

    if (!senderPosId) {
      setAvailableQuantities((prev) => ({
        ...prev,
        [quantityKey]: {
          quantity: null,
          message: "Veuillez sélectionner un point de vente d'origine",
        },
      }));
      return;
    }

    if (!productId) {
      setAvailableQuantities((prev) => {
        const newState = { ...prev };
        delete newState[quantityKey];
        return newState;
      });
      return;
    }

    const productInfo = PublicProducts?.find((p) => p.id === productId);
    if (senderPosId == "0") {
      setAvailableQuantities((prev) => ({
        ...prev,
        [quantityKey]: {
          quantity: productInfo.quantity,
          message: null,
        },
      }));
    } else {
      if (productInfo) {
        const posInfo = productInfo.points_of_sale.find(
          (pos) => pos.id === parseInt(senderPosId)
        );

        if (posInfo) {
          // Update the available quantity for the selected product
          setAvailableQuantities((prev) => ({
            ...prev,
            [quantityKey]: {
              quantity: posInfo.pivot.quantity,
              message: null,
            },
          }));
        } else {
          // If no matching POS is found, set quantity to 0 with appropriate message
          setAvailableQuantities((prev) => ({
            ...prev,
            [quantityKey]: {
              quantity: 0,
              message: "Ce produit n'est pas disponible dans ce point de vente",
            },
          }));
        }
      }
    }
  };

  // Update the handleProductChange function to use the composite key
  const handleProductChange = (receiverIndex, productIndex, newValue) => {
    const quantityKey = `${receiverIndex}-${productIndex}`;

    if (newValue) {
      updateProduct(receiverIndex, productIndex, "product_id", newValue.id);
      updateAvailableQuantity(receiverIndex, productIndex, newValue.id);
    } else {
      // Clear product_id and remove available quantity display
      updateProduct(receiverIndex, productIndex, "product_id", "");
      setAvailableQuantities((prev) => {
        const newState = { ...prev };
        delete newState[quantityKey];
        return newState;
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form
    if (!senderPosId) {
      toast.error("Veuillez sélectionner un point de vente d'origine");
      return;
    }

    for (let i = 0; i < receivers.length; i++) {
      if (!receivers[i].receiver_pos_id) {
        toast.error(
          `Veuillez sélectionner un point de vente destinataire pour le groupe ${i + 1
          }`
        );
        return;
      }

      if (receivers[i].receiver_pos_id === senderPosId) {
        toast.error(
          `Le point de vente destinataire ne peut pas être le même que l'origine pour le groupe ${i + 1
          }`
        );
        return;
      }

      for (let j = 0; j < receivers[i].products.length; j++) {
        if (!receivers[i].products[j].product_id) {
          toast.error(
            `Veuillez sélectionner un produit pour le groupe ${i + 1
            }, produit ${j + 1}`
          );
          return;
        }
        if (receivers[i].products[j].quantity <= 0) {
          toast.error(
            `La quantité doit être supérieure à 0 pour le groupe ${i + 1
            }, produit ${j + 1}`
          );
          return;
        }
      }
    }

    // Create payload
    const payload = {
      sender_pos_id: parseInt(senderPosId),
      receivers: receivers.map((receiver) => ({
        receiver_pos_id: parseInt(receiver.receiver_pos_id),
        products: receiver.products.map((product) => ({
          product_id: parseInt(product.product_id),
          quantity: parseInt(product.quantity),
        })),
      })),
    };

    transferMutation.mutate(payload);
  };

  // Filtrer produits selon la disponibilité dans le point de vente d'origine
  const filteredProducts = React.useMemo(() => {
    if (!PublicProducts) return [];

    // Si le POS d'origine est "KD Marché" (id = 0), on affiche la quantité globale
    if (senderPosId === "0") {
      return PublicProducts.filter((p) => p.quantity > 0);
    }

    // Sinon, on regarde la quantité dans le POS sélectionné
    const senderId = parseInt(senderPosId);

    return PublicProducts.filter((product) => {
      const posInfo = product.points_of_sale?.find(
          (pos) => pos.id === senderId
      );
      return posInfo && posInfo.pivot.quantity > 0;
    });
  }, [PublicProducts, senderPosId]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50"
      style={{ zIndex: 9990, overflow: "auto" }}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75"
        aria-hidden="true"
        onClick={() => setOpen(false)}
      />

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative w-full max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex justify-between items-center p-6 bg-[#b269ae] border-b border-gray-500/30">
            <h3
              id="modal-title"
              className="text-lg font-medium leading-6 text-white"
            >
              Créer un Transfert de Stock
            </h3>
            <button
              type="button"
              className="inline-flex items-center justify-center p-1.5 text-white hover:text-gray-200 hover:scale-105 duration-200"
              onClick={() => setOpen(false)}
            >
              <RiCloseLine className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            {/* Sender POS Selection */}
            <div className="mb-6">
              <label
                htmlFor="sender_pos"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Point de vente d'origine
              </label>
              {posLoading ? (
                <div className="flex justify-center">
                  <Puff color="#b269ae" height={30} width={30} />
                </div>
              ) : (
                <select
                  id="sender_pos"
                  value={senderPosId}
                  onChange={(e) => setSenderPosId(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-[#b269ae] focus:border-[#b269ae]"
                >
                  <option value="">Sélectionnez un point de vente</option>
                  <option value="0">KD Marché</option>

                  {posData?.data?.map((pos) => (
                    <option key={pos.id} value={pos.id}>
                      {pos.name}
                    </option>
                  ))}
                </select>
              )}
            </div>

            {/* Receivers Section */}
            <div className="space-y-8">
              <div className="flex justify-between items-center">
                <h4 className="text-lg font-medium text-gray-700">
                  Points de vente destinataires
                </h4>
                <button
                  type="button"
                  onClick={addReceiver}
                  className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-[#b269ae] hover:bg-[#a058a0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#b269ae]"
                >
                  <FaPlus className="mr-2" /> Ajouter un destinataire
                </button>
              </div>

              {receivers.map((receiver, receiverIndex) => (
                <div
                  key={receiverIndex}
                  className="p-4 border border-gray-200 rounded-lg shadow-sm bg-gray-50"
                >
                  <div className="flex justify-between items-center mb-4">
                    <h5 className="text-md font-medium text-gray-700">
                      Destinataire {receiverIndex + 1}
                    </h5>
                    {receivers.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeReceiver(receiverIndex)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>

                  {/* Receiver POS Selection */}
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Point de vente destinataire
                    </label>
                    {posLoading ? (
                      <div className="flex justify-center">
                        <Puff color="#b269ae" height={30} width={30} />
                      </div>
                    ) : (
                      <select
                        value={receiver.receiver_pos_id}
                        onChange={(e) =>
                          updateReceiverPosId(receiverIndex, e.target.value)
                        }
                        className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-[#b269ae] focus:border-[#b269ae]"
                      >
                        <option value="">Sélectionnez un point de vente</option>
                        <option value="0">KD Marché</option>
                        {posData?.data
                          ?.filter((pos) => pos.id != senderPosId)
                          .map((pos) => (
                            <option key={pos.id} value={pos.id}>
                              {pos.name}
                            </option>
                          ))}
                      </select>
                    )}
                  </div>

                  {/* Products Section */}
                  <div className="space-y-4">
                    <div className="flex justify-between items-center">
                      <h6 className="text-sm font-medium text-gray-700">
                        Produits
                      </h6>
                      <button
                        type="button"
                        onClick={() => addProduct(receiverIndex)}
                        className="inline-flex items-center px-2 py-1 border border-transparent text-xs leading-4 font-medium rounded-md text-white bg-[#b269ae] hover:bg-[#a058a0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#b269ae]"
                      >
                        <FaPlus className="mr-1" /> Ajouter un produit
                      </button>
                    </div>

                    {receiver.products.map((product, productIndex) => (
                      <div
                        key={productIndex}
                        className="grid grid-cols-12 gap-4 items-center bg-white p-3 rounded-md shadow-sm"
                      >
                        {/* Product Selection with Autocomplete */}
                        <div className="col-span-8">
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Produit
                          </label>
                          <Autocomplete
                              options={filteredProducts}
                              getOptionLabel={(option) => option.title || ""}
                            onChange={(event, newValue) =>
                              handleProductChange(
                                receiverIndex,
                                productIndex,
                                newValue
                              )
                            }
                            loading={productsLoading && searchTerm.length > 2}
                            loadingText="Chargement des produits..."
                            noOptionsText={
                              searchTerm.length <= 2
                                ? "Tapez au moins 3 caractères..."
                                : "Aucun produit trouvé"
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            slotProps={{ popper: { sx: { zIndex: 10000 } } }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Rechercher un produit..."
                                variant="outlined"
                                size="small"
                                fullWidth
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {productsLoading &&
                                        searchTerm.length > 2 ? (
                                        <Puff
                                          color="#b269ae"
                                          height={20}
                                          width={20}
                                        />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                          {/* Display available quantity or message */}
                          {availableQuantities[
                            `${receiverIndex}-${productIndex}`
                          ] && (
                              <p
                                className={`text-xs mt-1 ${availableQuantities[
                                  `${receiverIndex}-${productIndex}`
                                ].message
                                  ? "text-amber-600"
                                  : availableQuantities[
                                    `${receiverIndex}-${productIndex}`
                                  ].quantity > 0
                                    ? "text-green-600"
                                    : "text-red-600"
                                  }`}
                              >
                                {availableQuantities[
                                  `${receiverIndex}-${productIndex}`
                                ].message ||
                                  `Quantité disponible: ${availableQuantities[
                                    `${receiverIndex}-${productIndex}`
                                  ].quantity
                                  }`}
                              </p>
                            )}
                        </div>

                        {/* Quantity Input */}
                        <div className="col-span-3">
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Quantité
                          </label>
                          <input
                            type="number"
                            min="1"
                            value={product.quantity}
                            onChange={(e) =>
                              updateProduct(
                                receiverIndex,
                                productIndex,
                                "quantity",
                                e.target.value
                              )
                            }
                            className="w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-[#b269ae] focus:border-[#b269ae]"
                          />
                        </div>

                        {/* Remove Product Button */}
                        <div className="col-span-1 flex items-end justify-center">
                          {receiver.products.length > 1 && (
                            <button
                              type="button"
                              onClick={() =>
                                removeProduct(receiverIndex, productIndex)
                              }
                              className="text-red-500 hover:text-red-700 p-2"
                            >
                              <FaTrash />
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Submit Button */}
            <div className="mt-8 flex justify-end">
              <button
                type="submit"
                disabled={transferMutation.isLoading}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#b269ae] hover:bg-[#a058a0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#b269ae] disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {transferMutation.isLoading ? (
                  <>
                    <Puff
                      color="white"
                      height={16}
                      width={16}
                      className="mr-2"
                    />
                    Création en cours...
                  </>
                ) : (
                  "Créer le transfert"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddTransferModal;
